// AFRAME.THREE is available after 'import aframe' in main.js.
// Using AFRAME.THREE (not window.THREE or a separate 'three' import) ensures
// we reference the same Three.js instance A-Frame uses, avoiding dual-instance issues.

AFRAME.registerComponent('billboard', {
  init: function () {
    this._camPos = new AFRAME.THREE.Vector3();
  },
  tick: function () {
    // Lazy cache: avoids 26 × sceneEl.camera dereferences per frame (1,872/sec at 72fps).
    if (!this._camera) {
      this._camera = this.el.sceneEl.camera;
      if (!this._camera) { return; }
    }
    // Use setFromMatrixPosition — NOT camera.getWorldPosition().
    // getWorldPosition() calls updateWorldMatrix(true) which overwrites the
    // WebXR-owned camera matrix with stale local-space data (Three.js bug #18448).
    this._camPos.setFromMatrixPosition(this._camera.matrixWorld);
    this.el.object3D.lookAt(this._camPos);
  },
});

if (import.meta.hot) { import.meta.hot.decline(); }
